/**
 * RefBadge.jsx — Badge visuel affichant le code du référentiel officiel AM (ex "S4.G")
 * sur chaque section d'un cours (Journée 1, Journée 2, Sensibilisation).
 *
 * Usage : <RefBadge slug={cours.slug} num={section.num} />
 * Ne rend rien si aucun refCode n'est mappé pour la section.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { getRefForSection, refColor } from '../data/referentielAM';

export function RefBadge({ slug, num, variant = 'inline' }) {
  const code = getRefForSection(slug, num);
  if (!code) return null;

  const c = refColor(code);
  if (!c) return null;

  // Style compact "chip" à côté du kicker
  return (
    <Link
      to="/permis-am/programme"
      className={`inline-flex items-center gap-1 rounded-md ${c.solid} text-white text-[10px] font-black uppercase tracking-widest px-2 py-0.5 shadow hover:opacity-90 active:scale-95 transition align-middle ml-2`}
      title={`Référentiel officiel · ${c.label}`}
      data-testid={`ref-badge-${num}`}
    >
      <span className="opacity-70">Réf.</span>
      <span>{code}</span>
    </Link>
  );
}

export default RefBadge;
